<template>
  <a-form
    ref="formState"
    :model="formState"
    :rules="rules"
    v-bind="{
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 14,
      },
    }"
  >
    <a-form-item label="姓名" name="pass">
      <a-input v-model:value="formState.name" type="text" />
    </a-form-item>
    <a-form-item label="公司" name="pass">
      <a-input v-model:value="formState.company" type="text" />
    </a-form-item>
    <a-form-item label="电话" name="pass">
      <a-input v-model:value="formState.phone" type="text" />
    </a-form-item>
    <a-form-item label="地址" name="pass">
      <a-input v-model:value="formState.address" type="text" />
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="$confirm(target, formState)">确认</a-button>
      <a-button style="margin-left: 10px" @click="$reset(defaultState)">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script>
export default {
  data() {
    return {
      targetName: "customer",
      target: null,
      defaultState: {},
      formState: {
        name: "",
        company: "",
        phone: "",
        address: "",
      },
    };
  },
  async mounted() {
    this.$loadDetail()
  },
  methods: {
  },
};
</script>
